module.exports = __webpack_public_path__ + "img/create-acct-bg.1ac67831.1ac67831.png";